import "./CTA.css";
import ctaData from "../../data/ctaData";
import { Link } from "react-router-dom";
const CTA = () => {
  return (
    <section className="cta">
      {/* Background Overlay */}
      <div className="cta-overlay"></div>

      <div className="cta-container">
        {/* Left Content */}
        <div className="cta-content">
          <span className="cta-tag">READY TO START?</span>

          <h2>
            Build Your Dream
            <br />
            Sports Infrastructure
          </h2>

          <p>
            We design and construct world-class Basketball Courts, Tennis
            Courts, Football Turf, Pickleball Courts, Running Tracks and
            Multi-Sport Facilities using premium international standards.
          </p>

          {/* Features */}

          <div className="cta-features">
            {ctaData.features.map((item, index) => (
              <div className="cta-feature" key={index}>
                <span>{item.icon}</span>

                <p>{item.text}</p>
              </div>
            ))}
          </div>

          {/* Buttons */}

          <div className="cta-buttons">
            <Link to="/contact" className="cta-primary">
              Get Free Consultation
            </Link>

            <button className="cta-secondary">Call Now</button>
          </div>
        </div>

        {/* Right Side */}

        <div className="cta-image">
          <img src={ctaData.image} alt="Sports Construction" />
        </div>
      </div>
    </section>
  );
};

export default CTA;
